import { render, staticRenderFns } from "./AppMenuItemSettings.vue?vue&type=template&id=76f18386&scoped=true"
import script from "./AppMenuItemSettings.vue?vue&type=script&lang=ts"
export * from "./AppMenuItemSettings.vue?vue&type=script&lang=ts"
import style0 from "./AppMenuItemSettings.vue?vue&type=style&index=0&id=76f18386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f18386",
  null
  
)

export default component.exports